require('./bootstrap');
require('./plugins');
require('owl.carousel');

(function($) {
    'use strict';

    jQuery(document).ready(function($) {
        $('.product-carousel').owlCarousel({
            items: 4,
            loop: true,
            dots: false,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            smartSpeed: 500,
            margin: 30,
            responsive: {
                0: {
                    items: 1,
                },
                576: {
                    items: 2,
                },
                992: {
                    items: 4,
                },
            },
        });

        // All Window Scroll Function
        $(window).scroll(function () {
            // Scroll top Hide Show
            if ($(window).scrollTop() >= 400) {
                $('.scrolltotop').addClass('show');
            } else {
                $('.scrolltotop').removeClass('show');
            }
        });

        // Scroll to top
        $('.scrolltotop').smoothScroll({
            direction: 'top',
            scrollTarget: 'html',
            speed: 600
        });

        // Responsive Menu Slicknav
        $('.mainmenu').slicknav({
            label: '',
            prependTo: '.navigation-area',
            closedSymbol: '+',
            openedSymbol: '-',
            init: function () {
                $('.slicknav_nav').find('ul').removeClass('dropdown-nav');
                $('.slicknav_nav').find('li').removeClass('dropdown-show');
                $('.slicknav_nav').find('a').removeClass('arrow-toggle');
            }
        });

        // Product Thumbnail Carousel JS
        $('.product-thumb-carousel').owlCarousel({
            loop: true,
            items: 1,
            dots: false,
            smartSpeed: 500,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            thumbs: true,
            thumbImage: true,
            thumbContainerClass: 'owl-thumbs',
            thumbItemClass: 'owl-thumb-item'
        });

        $('[rel="tooltip"],[data-rel="tooltip"],[data-toggle="tooltip"]').tooltip({'placement': 'bottom', delay: {show: 400, hide: 200}});
    });
}(jQuery));
